import { AfterViewInit, Directive, ElementRef, inject, OnDestroy } from '@angular/core';
import { fromEvent, Subscription } from 'rxjs';

@Directive({
  selector: '[caCardContentAutoHeight]',
  standalone: true
})
export class CardContentAutoHeightDirective implements AfterViewInit, OnDestroy {
  private el = inject(ElementRef<HTMLElement>);
  private readonly bufferHeight = 60;
  private resizeSubscription?: Subscription;

  ngAfterViewInit(): void {
    this.resizeSubscription = fromEvent(window, 'resize').subscribe(() => this.updateHeight());

    requestAnimationFrame(() => this.updateHeight());
  }

  private updateHeight(): void {
    const rect = this.el.nativeElement.getBoundingClientRect();
    const viewportHeight = window.innerHeight;

    const availableHeight = viewportHeight - rect.top - this.bufferHeight;

    if (availableHeight > 100) {
      this.el.nativeElement.style.height = `${availableHeight}px`;
    }
  }

  ngOnDestroy(): void {
    this.resizeSubscription?.unsubscribe();
  }
}
